module.exports = __webpack_public_path__ + "img/pet1.cf3ca97a.png";